module.exports = __webpack_public_path__ + "img/Speaker=Denis Repin.ef9bab13.png";